"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var SupportPromoDetailListCtl = /** @class */ (function (_super) {
    __extends(SupportPromoDetailListCtl, _super);
    function SupportPromoDetailListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key_uid = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key_uid; });
        _this.dk_promocode = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_promo_tpl_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_tpl_title; });
        _this.dk_promo_tpl_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_tpl_description; });
        _this._errDialog = errDialog;
        return _this;
    }
    SupportPromoDetailListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total_count: 0,
        };
    };
    SupportPromoDetailListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListAvailPromoCodesListByPromoCodePart.exec({
            brand_id_list: data.brands_id_list,
            all_brands: data.all_brands,
            partial_code: data.promocode_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total_count = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key_uid: resp.list[i].key_uid,
                    promocode: resp.list[i].promocode,
                    partner_login: resp.list[i].partner_login,
                    brand_title: resp.list[i].brand_title,
                    promo_tpl_title: resp.list[i].promo_tpl_title,
                    promo_tpl_description: resp.list[i].promo_tpl_description
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return SupportPromoDetailListCtl;
}(BaseController_1.BaseController));
exports.SupportPromoDetailListCtl = SupportPromoDetailListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_promo_detail/ctl/SupportPromoDetailListCtl.ts
// module id = 1029
// module chunks = 0